import { JobsDashboardUtils } from "./jobs-dashboard-utils";
import { FormBase } from "../../util/form-base-form";

export class JobsDashboardForm extends FormBase {
    private readonly root: HTMLElement;

    private readonly roles = JobsDashboardUtils.ROLES;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public static getRoots(scope: Document | HTMLElement | ParentNode = document): HTMLElement[] {
        const selector = `[data-role="${JobsDashboardUtils.ROLES.ROOT}"]`;
        const roots: HTMLElement[] = [];
        if (scope instanceof HTMLElement && scope.matches(selector)) {
            roots.push(scope);
        }
        return roots.concat(this.prototype.queryElements.call(this.prototype, scope, selector, HTMLElement));
    }

    public getRoot(): HTMLElement {
        return this.root;
    }

    public isInitialized(): boolean {
        return this.root.dataset.jobsDashboardInit === "1";
    }

    public markInitialized(): void {
        this.root.dataset.jobsDashboardInit = "1";
    }

    public getStatusEl(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${this.roles.STATUS}"]`, HTMLElement);
    }

    public getRefreshButton(): HTMLButtonElement | null {
        return this.getButton(this.root, `[data-role="${this.roles.REFRESH}"]`);
    }

    public getRunAllButton(): HTMLButtonElement | null {
        return this.getButton(this.root, `[data-role="${this.roles.RUN_ALL}"]`);
    }

    public getListEl(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${this.roles.LIST}"]`, HTMLElement);
    }

    public getLatestResultEl(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${this.roles.LATEST_RESULT}"]`, HTMLElement);
    }

    public getHistoryPanelEl(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${this.roles.HISTORY_PANEL}"]`, HTMLElement);
    }

    public getHistoryCardEl(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${this.roles.HISTORY_CARD}"]`, HTMLElement);
    }

    public getHistoryTitleEl(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${this.roles.HISTORY_TITLE}"]`, HTMLElement);
    }

    public getHistoryListEl(): HTMLElement | null {
        return this.queryElement(this.root, `[data-role="${this.roles.HISTORY_LIST}"]`, HTMLElement);
    }

    public getHistoryCloseButton(): HTMLButtonElement | null {
        return this.getButton(this.root, `[data-role="${this.roles.HISTORY_CLOSE}"]`);
    }

    public getRunButton(target: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, `[data-role="${this.roles.RUN_BUTTON}"]`, HTMLButtonElement);
    }

    public getAbortButton(target: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, `[data-role="${this.roles.ABORT_BUTTON}"]`, HTMLButtonElement);
    }

    public getEditButton(target: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, `[data-role="${this.roles.EDIT_BUTTON}"]`, HTMLButtonElement);
    }

    public getSaveButton(target: EventTarget | Element | null | undefined): HTMLButtonElement | null {
        return this.closest(target, `[data-role="${this.roles.SAVE_BUTTON}"]`, HTMLButtonElement);
    }

    public getRow(target: EventTarget | Element | null | undefined): HTMLElement | null {
        return this.closest(target, ".jobs-dashboard__row", HTMLElement);
    }

    public getScheduleTypeSelect(row: ParentNode): HTMLSelectElement | null {
        return this.queryElement(row, '[data-field="schedule_type"]', HTMLSelectElement);
    }

    public getScheduleTimeInput(row: ParentNode): HTMLInputElement | null {
        return this.queryElement(row, '[data-field="schedule_time"]', HTMLInputElement);
    }

    public getScheduleDayInput(row: ParentNode): HTMLInputElement | null {
        return this.queryElement(row, '[data-field="schedule_day"]', HTMLInputElement);
    }

    public getIsActiveSelect(row: ParentNode): HTMLSelectElement | null {
        return this.queryElement(row, '[data-field="is_active"]', HTMLSelectElement);
    }
}
